import React from 'react'
import { Outlet } from 'react-router-dom'
import Activity from '../components/Activity'
import UserSelector from '../components/UserSelector'

const RecommendationLayout = () => {
  return (
    <div>
      <div className='dashboard-heading'>
        <div className='content-container'>
          <h2>Recommentation</h2>
          <p>Find recommendations based on your strengths and weakness</p>
        </div>
        <Activity />
      </div>
      <UserSelector />

      <div className='dashboard-cards rounded-0 p-0'>
        <Outlet />
      </div>
    </div>
  )
}

export default RecommendationLayout
